import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { createEventAction, editEventAction, getEventsAction } from '../../../../actions/events';
import { getCompanyLocations, getLocationsListAction, addUserLocation } from '../../../../actions/locations';
import { getAllSkills } from '../../../../actions/skills';
import { getJobDetails, getPayCostRateAction, editJobAction } from '../../../../actions/jobs';
import { getAllDressCodesAction } from '../../../../actions/dressCode';
import { UIShowConfirm, UIShowAlert } from '../../../../actions/ui';
import { yearMonthDayFormat } from '../../../../constants/date';
import { isJobHasNotStarted, isJobNotEditable } from '../../../../helpers/jobs';
import { getJobCostRateDollarPrice, getWorkerPayRateDollarPrice } from '../../../../helpers/general';
import UserInfo from './UserInfo';
import EventInfo from './EventInfo';
import GeneralInfo from './GeneralInfo';
import Skills from './Skills';
import Description from './Description';
import WhereToReport from './WhereToReport';
import DressCode from './DressCode';
import UsersService from '../../../../services/UsersService';

class JobDetailsTab extends Component {
  static propTypes = {
    jobDetails: PropTypes.object.isRequired,
    userEventsList: PropTypes.array.isRequired,
    locationsList: PropTypes.array.isRequired,
    skillsList: PropTypes.array.isRequired,
    costPayRateList: PropTypes.array.isRequired,
    dressCodesList: PropTypes.array.isRequired,
    companyLocations: PropTypes.array.isRequired,
    getJobDetails: PropTypes.func.isRequired,
    editJobAction: PropTypes.func.isRequired,
    cancelJob: PropTypes.func.isRequired,
    createEventAction: PropTypes.func.isRequired,
    editEventAction: PropTypes.func.isRequired,
    getEventsAction: PropTypes.func.isRequired,
    getLocationsListAction: PropTypes.func.isRequired,
    getCompanyLocations: PropTypes.func.isRequired,
    addUserLocation: PropTypes.func.isRequired,
    getPayCostRateAction: PropTypes.func.isRequired,
    getAllSkills: PropTypes.func.isRequired,
    getAllDressCodesAction: PropTypes.func.isRequired,
    UIShowConfirm: PropTypes.func.isRequired,
    UIShowAlert: PropTypes.func.isRequired,
    calculateEstCost: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    const { job_cost_rate, worker_pay_rate } = props.jobDetails;
    this.state = {
      job_cost_rate,
      worker_pay_rate
    };
  }

  componentDidMount () {
    this.getEventsList();
  }

  getEventsList = () => {
    const { getEventsAction, jobDetails } = this.props;
    const { company_id, start_date, time_zone_id } = jobDetails;
    const jobStartDate = moment(start_date).format(yearMonthDayFormat);
    return getEventsAction(company_id, time_zone_id, jobStartDate);
  };

  editJob = jobData => {
    const { editJobAction, getJobDetails, jobDetails: { id } } = this.props;
    return editJobAction(id, jobData).then(() => getJobDetails(id));
  };

  updateJobRates = ({ job_cost_rate, worker_pay_rate }) => {
    if (!_.isUndefined(job_cost_rate)) {
      this.props.calculateEstCost({ job_cost_rate });
    }
    this.setState(prevState => ({
      job_cost_rate: _.isUndefined(job_cost_rate) ? prevState.job_cost_rate : job_cost_rate,
      worker_pay_rate: _.isUndefined(worker_pay_rate) ? prevState.worker_pay_rate : worker_pay_rate
    }));
  };

  getCostPayRateByData = data => {
    const { getPayCostRateAction, jobDetails } = this.props;
    const job_skill_id = data.job_skill_id || jobDetails.job_skill_id;
    const job_coordinates = data.address_coordinates || jobDetails.address_coordinates;
    const state = data.state || jobDetails.state;
    const { company_id } = jobDetails;
    getPayCostRateAction({
      job_skill_id,
      job_coordinates,
      state,
      company_id
    }).then(() => {
      const job_cost_rate = getJobCostRateDollarPrice(this.props.costPayRateList);
      const worker_pay_rate = getWorkerPayRateDollarPrice(this.props.costPayRateList);
      this.updateJobRates({ job_cost_rate, worker_pay_rate });
    });
  };

  render () {
    const { jobDetails, getJobDetails, cancelJob, userEventsList, createEventAction, UIShowConfirm, editEventAction,
      companyLocations, addUserLocation, getCompanyLocations, getLocationsListAction, locationsList, skillsList,
      getAllSkills, dressCodesList, getAllDressCodesAction, UIShowAlert, calculateEstCost } = this.props;
    const { employer: { first_name, last_name, photo_image_url, email, phone, is_company, company_logo_url, company_name },
      user_id, company_id, status, is_approved, start_date, time_zone_id } = jobDetails;
    const { job_cost_rate, worker_pay_rate } = this.state;
    const jobIsNotEditable = isJobNotEditable(status, is_approved);
    const isAdmin = UsersService.isAdmin();
    const jobHasNotStarted = isJobHasNotStarted(start_date, time_zone_id);
    const showEditIcons = !jobIsNotEditable && jobHasNotStarted;
    return (
      <main className='main-wrapper-details-blocks'>
        { isAdmin && (
          <Fragment>
            <UserInfo
              userId={user_id}
              userPhoto={photo_image_url}
              firstName={first_name}
              lastName={last_name}
              email={email}
              phone={phone}
              isCompany={is_company}
              companyLogoUrl={company_logo_url}
              companyName={company_name}
              companyId={company_id}
            />
            <EventInfo
              showEditIcons={showEditIcons}
              jobDetails={jobDetails}
              userEventsList={userEventsList}
              createEventAction={createEventAction}
              editJob={this.editJob}
              editEventAction={editEventAction}
              UIShowConfirm={UIShowConfirm}
              getJobDetails={getJobDetails}
            />
          </Fragment>
        )}
        <GeneralInfo
          jobDetails={jobDetails}
          jobRates={{ job_cost_rate, worker_pay_rate }}
          showEditIcons={showEditIcons}
          getEventsList={this.getEventsList}
          editJob={this.editJob}
          getCompanyLocations={getCompanyLocations}
          companyLocations={companyLocations}
          addUserLocation={addUserLocation}
          getLocationsListAction={getLocationsListAction}
          locationsList={locationsList}
          getCostPayRateByData={this.getCostPayRateByData}
          updateJobRates={this.updateJobRates}
          UIShowAlert={UIShowAlert}
          calculateEstCost={calculateEstCost}
        />
        { isAdmin && (
          <Skills
            jobDetails={jobDetails}
            jobRates={{ job_cost_rate, worker_pay_rate }}
            showEditIcons={showEditIcons}
            skillsList={skillsList}
            getAllSkills={getAllSkills}
            editJob={this.editJob}
            getCostPayRateByData={this.getCostPayRateByData}
            updateJobRates={this.updateJobRates}
          />
        )}
        <Description
          description={jobDetails.description}
          showEditIcons={showEditIcons}
          editJob={this.editJob}
        />
        <WhereToReport
          where_to_report={jobDetails.where_to_report}
          showEditIcons={showEditIcons}
          editJob={this.editJob}
        />
        <DressCode
          dress_code={jobDetails.dress_code}
          dress_code_id={jobDetails.dress_code_id}
          showEditIcons={showEditIcons}
          editJob={this.editJob}
          dressCodesList={dressCodesList}
          getAllDressCodesAction={getAllDressCodesAction}
        />
        { !jobIsNotEditable && (
          <button
            className='button button-delete mx-auto'
            onClick={cancelJob}
          >Cancel Job</button>
        )}
      </main>
    );
  }
}

const mapStateToProps = state => ({
  jobDetails: state.jobs.jobDetails,
  userEventsList: state.events.userEventsList,
  locationsList: state.locations.locationsList,
  skillsList: state.skillsList,
  costPayRateList: state.jobs.costPayRateList,
  dressCodesList: state.dressCodesList,
  companyLocations: state.companyLocations
});

const mapDispatchToProps = {
  getJobDetails,
  editJobAction,
  createEventAction,
  editEventAction,
  getEventsAction,
  getLocationsListAction,
  getCompanyLocations,
  addUserLocation,
  getPayCostRateAction,
  getAllSkills,
  getAllDressCodesAction,
  UIShowConfirm,
  UIShowAlert
};

export default connect(mapStateToProps, mapDispatchToProps)(JobDetailsTab);



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/JobDetailsTab/index.js